"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var agent_1 = __importDefault(require("@egjs/agent"));
var errorHandler_1 = require("../api/errorHandler");
var agent = agent_1.default();
// Default error handler
exports.handlErr = function (e, additionalData) {
    if (additionalData === void 0) { additionalData = {
        eventId: '',
        userEmail: '',
        region: '',
        others: {},
    }; }
    var ErrorData = {
        message: e.message,
        name: e.name,
        stack: e.stack,
        eventId: additionalData.eventId,
        userEmail: additionalData.userEmail,
        region: additionalData.region,
        browserInfo: JSON.stringify(agent),
        others: additionalData.others,
    };
    errorHandler_1.errorHandler(ErrorData);
    console.error(e); // eslint-disable-line no-console
};
exports.default = exports.handlErr;
//# sourceMappingURL=error-handler.js.map